import { RolesName } from "configs/roles";

export const isExistsRoles = (authRole) => {
  const roles = [
    RolesName.ROLES_SUPERADMIN,
    RolesName.ROLES_OPERATOR,
    RolesName.ROLES_USER,
  ];
  return roles.includes(authRole);
};
